// extracted by mini-css-extract-plugin
module.exports = {"SignUpPageContainer":"SignUp_SignUpPageContainer__uuvkB","HideOnMobile":"SignUp_HideOnMobile__1Oa_L","EmbeddedFrame":"SignUp_EmbeddedFrame__1zSsf"};